<template>
<div>
  <token-verification ref="refTokenVerification" />

  <div v-if="confirmedUserName" class="container">
      <div tabindex="0" class="e-card" id="basic">
          <div class="e-card-title">Success</div>
          <div class="e-card-separator"></div>
            <div class="e-card-content margin-color-verify-section">
                 <p>
                    Your email has been verified.
                    You can now login to your account using your new email by clicking
                    <ejs-button
                        cssClass="e-link"
                        v-on:click.native="onLoginClick"
                        style="padding: 3px">
                        here
                    </ejs-button>
                    or using the Sign In button.
                </p>
            </div>
          </div>
  </div>
</div>
</template>

<script>
import TokenVerification from '../components/token-varification.vue';

export default {
  name: 'VerifyToken',
  components: {
    TokenVerification,
  },
  data() {
    return {
    };
  },
  computed: {
    confirmedUserName() {
      return this.$store.getters.confirmedUserName;
    },
  },
  methods: {
    onLoginClick() {
      this.$router.push('/login');
    },
  },
  watch: {
  },
};
</script>
<style>
.container {
  padding: 16px 25% 16px 25%;
}
.e-card-title{
  background: #0f4b90;
  color: white;
}
</style>
